export default __webpack_public_path__ + "static/JosefinSans-Regular-b0206b2ab81a90c99301bb243634aaad.woff";